import { render, staticRenderFns } from "./ErpcMemberList.vue?vue&type=template&id=e8ca8294"
import script from "./ErpcMemberList.vue?vue&type=script&lang=ts"
export * from "./ErpcMemberList.vue?vue&type=script&lang=ts"
import style0 from "./ErpcMemberList.vue?vue&type=style&index=0&id=e8ca8294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports